// src/layouts/Pages/PageHeader/ViewSelector.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Segmented, Tooltip } from 'antd';
import { useCallback, useMemo } from 'react';
import useZustand from 'hooks/useZustand';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ViewSelector = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const storedCurrentPage = useZustand('module', 'currentPage');
  const storedCurrentView = useZustand('module', 'currentView');
  const setCurrentViewStore = useZustand('module', 'setCurrentView');

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const viewSelector = storedCurrentPage?.header?.viewSelector;

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleChange = useCallback(
    value => {
      setCurrentViewStore(value);
    },
    [setCurrentViewStore]
  );

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const options = useMemo(() => {
    if (!Array.isArray(viewSelector)) return [];
    return viewSelector.map(opt => ({
      value: opt.value,
      label: (
        <Tooltip title={translateX(opt.tooltip || opt.value)} placement="bottom">
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            {opt.icon}
          </span>
        </Tooltip>
      ),
    }));
  }, [viewSelector]);

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (!viewSelector || !Array.isArray(viewSelector) || viewSelector.length < 2) return null;

  return (
    <>
      <style>{`
        .view-selector .ant-segmented-group,
        .view-selector .ant-segmented-item,
        .view-selector .ant-segmented-item-label {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>
      <Segmented
        className="view-selector"
        options={options}
        value={storedCurrentView || 'init'}
        onChange={handleChange}
        style={{ height: 40 }}
      />
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ViewSelector;
